import {AppDispatch} from '../redux/rootReducer';
import {AccountType} from '../types/AccountType';
import {postJsonData} from './requests';

export const updateAccount = (account: AccountType, dispatch: AppDispatch) => {
    const url = `api/1.0/accounts`;
    return postJsonData(url, JSON.stringify(account), dispatch, true);
};

export const updatePassword = (password: string, oldPassword: string, dispatch: AppDispatch) => {
    const url = `api/1.0/accounts/password`;
    return postJsonData(url, JSON.stringify({password, oldPassword}), dispatch, true);
};
